import React from 'react';

import 'tailwindcss/tailwind.css';
import 'leaflet';
import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet-lasso';
import 'heatmap.js';

import { Route, Routes } from 'react-router';
import HeaderMenuLayout from 'layout/HeaderMenuLayout';
import DummyComponent from 'campaignvis/CampaignVisHeader';
import DummyChildComponent from 'campaignvis/CampaignVisMainScreen';
import ForecastingContextProvider from 'components/ForecastingContextProvider';
import SampledAvails from './routes/SampledAvails';
import { useAuthRedirect } from 'Auth';

export default function App() {
    const [isLoading, isAuthenticated] = useAuthRedirect();

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (isAuthenticated !== undefined && !isAuthenticated) {
        return <div></div>
    }

    return (
        <Routes>
            <Route
                path='/:settings?'
                element={
                    <HeaderMenuLayout>
                        <ForecastingContextProvider>
                            <SampledAvails />
                        </ForecastingContextProvider>
                    </HeaderMenuLayout>
                }
            />
            <Route
                path='/campaign-visual?'
                element={
                    <DummyComponent>
                        <DummyChildComponent />
                    </DummyComponent>
                }
            />
        </Routes>
    );
}
